// DEPENDENCIES
import React from 'react';
// COMPONENTS
import {Link} from 'react-router-dom';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const ActionStrip = (props) => {

    return (
        <>
            <Link 
                className={`action-strip ${props.containerClassName ? props.containerClassName : ""} ${props.backgroundColor ? props.backgroundColor : "light--bg"} ${props.highlighted ? "highlighted" : ""}`}
                to={props.to ? props.to : "#"}
                onClick={props.primaryOnClick ? props.primaryOnClick : {}}
            >
                <CustomBlock>

                </CustomBlock>

                <CustomBlock className="action-strip-title-container">
                    <p className="action-strip-title">
                        {props.title}
                    </p>
                </CustomBlock>

                <Link
                    className="right-action-container"
                    to={props.rightActionTo ? props.rightActionTo : "#"}
                >
                    {
                        props.rightActionText &&
                        <p className={`right-action-text${props.badgeColor ? ("--badge" + " " + props.badgeColor) : ""}`}>{props.rightActionText}</p>
                    }

                    {
                        props.rightActionIcon
                    }
                </Link>
                
            </Link>
        </>
    )
}

export default ActionStrip;